import { useEffect } from "react";
import { useAuth } from "../hooks";

/**
 * LogoutPage
 * Triggers logout immediately on mount and navigates to sign-in.
 * Spec ref: AC-5 — POST /api/v1/logout, session invalidated.
 */
export function LogoutPage() {
    const { logout } = useAuth();

    useEffect(() => {
        logout();
    }, [logout]);

    return null;
}
